import { Box, Collapse, Grid, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { ReactComponent as AddUser } from "assets/AddUser.svg";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/ArrowUp.svg";
import ThemeContext from "components/app/Context";
import { getAllBreakupLists } from "components/features/MyLists/MyLists";
import { setProgressInfoSummary } from "components/features/Progress/Progress.slice";
import { cloneDeep, isNull, uniqueId } from "lodash";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { abovePropertyViewTypeProperty } from "utils/CommonConstants";
import { getTableColor, getUserNameByHltId } from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { getUserNameWithConditionalCheck } from "utils/SharedUtils";
import BookmarkPlan from "./Bookmark";
import CheckBox from "./Checkbox";
import MobileCommonTableForSCList from "./MobileTableForSCList";
import Typography from "./Typography";

const SCRow = (props: any) => {
  const { row, unCheckedMappings, setUnCheckedMappings, rowSelection } = props;
  const { isMobileScreen } = useContext(ThemeContext);

  const [open, setOpen] = useState<boolean>(false);
  const bookmarkedProperties = useAppSelector((state) => state.aboveProperty.bookmarkedProperties);
  const userInfo = getUserNameByHltId(props.allTeamMember, row?.inncodeMappingUserName);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  let renderListInfo;
  if (open && row.implementedPlansCountStatusBreakUp) {
    let implementedPlansCountStatusBreakUp = getAllBreakupLists(row.implementedPlansCountStatusBreakUp);
    const renderList = () => {
      return (
        <Grid>
          <Box>
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline} showBold>
              {row?.implementedPlansCount}
            </Typography>
          </Box>
          {implementedPlansCountStatusBreakUp?.map((item: any) => {
            return (
              <Grid key={uniqueId("TOOLTIP_ITEM_")} sx={{ color: getTableColor(item?.name), whiteSpace: "nowrap" }}>
                <Typography variant={"body2"} component={"span"} showBold>
                  {item.value < 10 ? "0" : ""}
                  {`${item.value ?? ""}  `}
                </Typography>
                {item?.name} {item?.isShowStar > 0 ? "*" : ""}
              </Grid>
            );
          })}
        </Grid>
      );
    };
    renderListInfo = renderList();
  }

  const filterIds = (obj1: any[], obj2: any) => {
    return obj1.filter((item) => !obj2.inncodeMappingIds.includes(item.id));
  };

  const handleParentCheckbox = (e: any, row: any, propIndex: any) => {
    const isChecked = e.target.checked;
    const clonedUnCheckedMappings = cloneDeep(unCheckedMappings);
    if (!isChecked) {
      let payload: any;
      if (row.inncodeusers.length > 1) {
        payload = row.inncodeusers.map((data: any, index: number) => {
          return {
            hltId: data,
            id: row.inncodeMappingIds[index],
            innCode: row.inncode
          };
        });
        clonedUnCheckedMappings.push(...payload);
      } else {
        payload = {
          hltId: row.inncodeMappingUserName,
          id: row.inncodeMappingIds[0],
          innCode: row.inncode
        };
        clonedUnCheckedMappings.push(payload);
      }
      setUnCheckedMappings(clonedUnCheckedMappings);
    } else {
      const res = filterIds(unCheckedMappings, row);
      setUnCheckedMappings(res);
    }
    props.handleParentChange(e, row, propIndex);
  };

  const getPropertyName = (property: any) => {
    if (property?.propertyName && property?.propertyName?.trim().length > 0) {
      return property?.propertyName;
    }
    return property?.inncode;
  };

  const handleChildCheckbox = (e: any, historyRow: any, historyIndex: any, index: any, row: any) => {
    const isChecked = e.target.checked;
    const clonedUnCheckedMappings = cloneDeep(unCheckedMappings);

    if (!isChecked) {
      let payload: any;
      payload = {
        hltId: historyRow.hltId,
        id: historyRow.mappingId,
        innCode: row.inncode
      };
      clonedUnCheckedMappings.push(payload);
      setUnCheckedMappings(clonedUnCheckedMappings);
    } else {
      const filteredItems = unCheckedMappings.filter((item: any) => item.id !== historyRow.mappingId);
      setUnCheckedMappings(filteredItems);
    }
    props.handleChildChange(index, historyIndex);
  };

  return (
    <>
      {!isMobileScreen ? (
        <React.Fragment key={uniqueId(`sc-row-${props.index}`)}>
          <TableRow sx={{ "& > *": { borderBottom: "unset" } }} className="sc-table-top-row">
            <TableCell>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => {
                  if (row.inncodeMappingUserName) {
                    setOpen(!open);
                    props.setId(row);
                    !open && props.fetchIndividualProperty(row, props.index);
                  }
                }}
              >
                {open ? <ArrowUp /> : <ArrowDown />}
              </IconButton>
            </TableCell>

            <TableCell component="th" scope="row" className="checkbox-row">
              <CheckBox
                checked={row.isChecked}
                disabled={!row.inncodeusers?.length}
                onChange={(e: any) => {
                  handleParentCheckbox(e, row, props.index);
                }}
              />
              <Typography
                variant="body2"
                showBold
                color="#312F2E"
                className={row?.implementedPlansCount > 0 ? "cursor-pointer" : ""}
                onClick={() => {
                  if (row?.implementedPlansCount > 0) {
                    navigate(`/progressInfo/property/${props.selectedList?.id}?inncode=${row?.inncode}`);
                    dispatch(setProgressInfoSummary(row));
                  }
                }}
              >
                {getPropertyName(row)}
              </Typography>
            </TableCell>
            <TableCell align="left" sx={{ verticalAlign: "top" }}>
              <Typography variant="body2" color="#312F2E">
                {row.inncode}
              </Typography>
            </TableCell>
            <TableCell align="left" size="medium" sx={{ verticalAlign: "top" }}>
              {row.inncodeusers?.length > 0 ? (
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <div
                    style={{
                      height: "32px",
                      padding: "0px 8px",
                      background: !open ? tokens.Background.General.Color : "#F6F5F3",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center"
                    }}
                  >
                    <Typography
                      color={!open ? tokens.Text.General.Color : "#897D74"}
                      variant="body2"
                      className="no-wrap-white-space"
                    >
                      {getUserNameWithConditionalCheck(userInfo?.displayName, userInfo?.firstName, userInfo?.lastName)}
                    </Typography>
                  </div>
                  {!open && row.inncodeusers?.length > 1 && (
                    <div>
                      <Typography variant="body2" color="#312F2E">
                        (+{row.inncodeusers?.length - 1})
                      </Typography>
                    </div>
                  )}
                </div>
              ) : (
                <div className="add-member">
                  <div
                    style={{
                      background: "white",
                      height: "34px",
                      width: "max-content",
                      display: "flex",
                      alignItems: "flex-start",
                      borderRadius: "200px",
                      cursor: "pointer"
                    }}
                    onClick={() => props.handleUserVisible({ isVisible: true, row: row, index: props.index })}
                  >
                    <Typography variant="label" showBold color="#007293">
                      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <AddUser /> Add Team Member
                      </div>
                    </Typography>
                  </div>
                </div>
              )}
            </TableCell>
            <TableCell align="left" sx={{ verticalAlign: "top" }}>
              <Typography variant="body2" color="#312F2E">
                {row.brandName}
              </Typography>
            </TableCell>
            <TableCell align="left" sx={{ verticalAlign: "top" }}>
              {!open ? (
                <Typography variant="body2" color="#312F2E">
                  {row.implementedPlansCount}
                </Typography>
              ) : (
                renderListInfo
              )}
            </TableCell>
            <TableCell align="left" sx={{ verticalAlign: "top" }}>
              <BookmarkPlan
                aboveUserPayload={{
                  isAboveUsertype: true,
                  viewType: abovePropertyViewTypeProperty,
                  inncode: row?.inncode
                }}
                isBookmarked={bookmarkedProperties?.some((b: any) => b?.innCode === row?.inncode)}
              />
            </TableCell>
          </TableRow>
          <TableRow className="sc-subtable-bottom">
            <TableCell
              style={{ paddingBottom: 0, paddingTop: 0 }}
              colSpan={6}
              sx={{ background: "#F6F5F3" }}
              className="parent-table-cell"
            >
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>
                          <Typography variant="body2" color="#3E3A39">
                            Last Assignment
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="#3E3A39">
                            Active Plans
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="#3E3A39">
                            Completed Plans
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="#3E3A39">
                            Engagement
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row.history?.map((historyRow: any, historyIndex: number) => {
                        const userInfo = getUserNameByHltId(props.allTeamMember, historyRow.hltId);
                        const userClickable =
                          row?.implementedPlansCount > 0 &&
                          (historyRow?.completedPlansCount > 0 || historyRow?.activePlansCount > 0);
                        return (
                          <TableRow key={uniqueId(`${row.propertyName}-${historyRow.innCode}`)}>
                            <TableCell className="hilton-id-cell" sx={{ display: "flex", alignItems: "center" }}>
                              <CheckBox
                                onChange={(e: any) => {
                                  handleChildCheckbox(e, historyRow, historyIndex, props.index, row);
                                }}
                                checked={historyRow.isChecked}
                              />
                              <div
                                style={{
                                  height: "32px",
                                  padding: "0px 8px",
                                  background: "#DBEDFF",
                                  borderRadius: "8px",
                                  display: "flex",
                                  alignItems: "center"
                                }}
                              >
                                <Typography
                                  color="#007293"
                                  variant="body2"
                                  className={
                                    userClickable ? "cursor-pointer no-wrap-white-space" : " no-wrap-white-space"
                                  }
                                  onClick={() => {
                                    if (userClickable) {
                                      const userData = {
                                        ...historyRow,
                                        displayName: getUserNameWithConditionalCheck(
                                          userInfo?.displayName,
                                          userInfo?.firstName,
                                          userInfo?.lastName
                                        )
                                      };
                                      navigate(
                                        `/progressInfo/users/${props.selectedList?.id}?inncode=${row?.inncode}&users=${historyRow.hltId}`
                                      );
                                      dispatch(setProgressInfoSummary(userData));
                                    }
                                  }}
                                >
                                  {getUserNameWithConditionalCheck(
                                    userInfo?.displayName,
                                    userInfo?.firstName,
                                    userInfo?.lastName
                                  )}
                                </Typography>
                              </div>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="#312F2E">
                                {isNull(historyRow.lastAssignmentDateTime)
                                  ? "-"
                                  : getUIFormatDate(historyRow.lastAssignmentDateTime)}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="#312F2E">
                                {historyRow.activePlansCount}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="#312F2E">
                                {historyRow.completedPlansCount}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="#312F2E">
                                {isNull(historyRow.engagement) ? "-" : historyRow.engagement}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      <TableRow>
                        <TableCell>
                          <div className="add-member">
                            <div
                              style={{
                                background: "white",
                                padding: "0px 16px",
                                height: "34px",
                                width: "max-content",
                                display: "flex",
                                alignItems: "center",
                                borderRadius: "200px",
                                cursor: "pointer"
                              }}
                              onClick={() => props.handleUserVisible({ isVisible: true, row: row, index: props.index })}
                            >
                              <Typography variant="label" showBold color="#007293">
                                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                  <AddUser /> Add Team Member
                                </div>
                              </Typography>
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
            {open && <TableCell className="adasadasd"></TableCell>}
          </TableRow>
        </React.Fragment>
      ) : (
        <MobileCommonTableForSCList
          {...props}
          filterIds={filterIds}
          handleParentCheckbox={handleParentCheckbox}
          handleChildCheckbox={handleChildCheckbox}
        />
      )}
    </>
  );
};

export default SCRow;
